import { queryOptions, useSuspenseQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { activitiesApi } from "../api/activities.api";
import { activityKeys } from "../constants/query-keys";

/** A city's categories with their counts, or every category without a city. */
export function categoriesQueryOptions(city: string | undefined, lang: string) {
  return queryOptions({
    queryKey: [...activityKeys.categories(city), lang],
    queryFn: () => activitiesApi.listCategories(city, lang),
  });
}

export function useCategories(city?: string) {
  const { i18n } = useTranslation();
  return useSuspenseQuery(categoriesQueryOptions(city, i18n.language));
}
